export const FTUE_ONBOARDING_MERCHANT = 'FTUE_ONBOARDING_MERCHANT';
export const FTUE_PAYMENT_CONFIG_SIDEBAR = 'FTUE_PAYMENT_CONFIG_SIDEBAR';
export const FTUE_PAYMENT_CONFIG_PAGE_TOUR = 'FTUE_PAYMENT_CONFIG_PAGE_TOUR';
export const FTUE_MWEB_FULL_SITE_SWITCH = 'FTUE_MWEB_FULL_SITE_SWITCH';
export const FTUE_MWEB_WELCOME_MODAL = 'FTUE_MWEB_WELCOME_MODAL';
export const FTUE_TAX_CONFIG_TOUR = 'FTUE_TAX_CONFIG_TOUR';
export const FTUE_SAUDAGAR_ASSOCIATION_POPUP =
  'FTUE_SAUDAGAR_ASSOCIATION_POPUP';
export const FTUE_ONLINE_STORE_GO_STORE_RED_DOT =
  'FTUE_ONLINE_STORE_GO_STORE_RED_DOT';
export const FTUE_ONLINE_STORE_FACEBOOK_RED_DOT =
  'FTUE_ONLINE_STORE_FACEBOOK_RED_DOT';
export const FTUE_ONLINE_STORE_GOOGLE_RED_DOT =
  'FTUE_ONLINE_STORE_GOOGLE_RED_DOT';
